export const ENDPOINT = 'https://repoassistant.ifi.uzh.ch/backend/';
//export const ENDPOINT = 'http://127.0.0.1:5678/';
export const TARGET_ACCESS = "access";
export const TARGET_DEMOGRAPHICS = "demographics";
export const TARGET_QUESTION = "question";
export const TARGET_FEEDBACK = "feedback";
export const TARGET_ANSWERS = "answers";
export const TARGET_END_OF_DAY = "endofday";

export function urlFor(target) {
    const url = new URL(target, ENDPOINT).toString();
    return url;
}

export class RequestAccess {
    constructor(authToken) {
        this.auth_token = authToken;
    }
}

export class ResponseAccess {
    constructor(isFull) {
        this.is_full = isFull;
    }
}

export class RequestQuestion {
    constructor(authToken, questionStr) {
        this.auth_token = authToken;
        this.question_str = questionStr;
    }
}

export class Answer {
    constructor(answerId, answerTxt) {
        this.answer_id = answerId;
        this.answer_txt = answerTxt;
    }
}

export class ResponseQuestion {
    constructor(qaId, epochRome) {
        this.qa_id = qaId;
        this.epoch_rome = epochRome;
    }
}

export class AgreeLevel {
    static o1 = "Strongly Disagree";
    static o2 = "Disagree";
    static o3 = "Neutral";
    static o4 = "Agree";
    static o5 = "Strongly Agree";
}

export class TaskName {
    static o1 = "Code";
    static o2 = "Debug";
    static o3 = "VC";
    static o4 = "Testing";
    static o5 = "Review";
    static o6 = "Other dev. task";
}

export class AnswerFeedback {
    constructor(answer_id, completeness, usefulness, relatedness, accuracy) {
        this.answer_id = answer_id;
        this.completeness = completeness;
        this.usefulness = usefulness;
        this.relatedness = relatedness;
        this.accuracy = accuracy;
    }
}

export class RequestFeedback {
    constructor(auth_token, qa_id, expertise, task_name, preferred_answer_id, types, overall, answer_feedbacks, user_preference = null) {
        this.auth_token = auth_token;
        this.qa_id = qa_id;
        this.expertise = expertise;
        this.task_name = task_name;
        this.preferred_answer_id = preferred_answer_id;
        this.user_preference = user_preference;
        this.types = types;
        this.overall = overall;
        this.answer_feedbacks = answer_feedbacks;
    }
}

export class ResponseFeedback {
}


export class ErrorAccess extends Error {
    constructor(message) {
        super(message);
        this.name = 'ErrorAccess';
    }
}

export class ErrorQuestion extends Error {
    constructor(message) {
        super(message);
        this.name = 'ErrorQuestion';
    }
}

export class ErrorFeedback extends Error {
    constructor(message) {
        super(message);
        this.name = 'ErrorFeedback';
    }
}

export class RequestAnswers {
    constructor(authToken) {
        this.auth_token = authToken;
    }
}

export class ResponseAnswers {
    constructor(requestQuestion, responseQuestion, qaId, answers) {
        this.request_question = requestQuestion;
        this.response_question = responseQuestion;
        this.qa_id = qaId;
        this.answers = answers;
    }
}

export class ErrorAnswers extends Error {
    constructor(message) {
        super(message);
        this.name = "ErrorAnswers";
    }
}

export class EducationLevel {
    static o1 = "High School but did not graduate";
    static o2 = "High School or GED";
    static o3 = "Some college or 2-year degree";
    static o4 = "BSc in CS";
    static o5 = "BSc in STEM";
    static o6 = "BSc in a different area than CS or STEM";
    static o7 = "MSc in CS";
    static o8 = "MSc in STEM";
    static o9 = "MSc in a different area than CS or STEM";
    static o10 = "PhD or higher academic title in CS";
    static o11 = "PhD or higher academic title in STEM";
    static o12 = "PhD or higher academic title in a different area than CS or STEM";
}

export class EmploymentStatus {
    static o1 = "Intern";
    static o2 = "Part-time";
    static o3 = "Full-time";
}

export class ActivityYearsName {
    static o1 = "Developed software in a professional setting (e.g., as employee of an IT-company or Open-Source contributor)";
    static o2 = "Programmed in Python (also not professionally)";
    static o3 = "Used AI-assisted tools such as Codex, ChatGPT, Copilot, etc.";
}

export class ActivityYearsAmount {
    static o1 = "None"
    static o2 = "1 year or less"
    static o3 = "2 years"
    static o4 = "3-5 years"
    static o5 = "6-10 years"
    static o6 = "11 years or more"
}

export class ActivityMonthsName {
    static o1 = "Designed code";
    static o2 = "Developed Code";
    static o3 = "Reviewed code";
    static o4 = "Used AI-assisted tools";
}

export class ActivityMonthsAmount {
    static o1 = "Not at all";
    static o2 = "About once";
    static o3 = "About once a month";
    static o4 = "About once a week";
    static o5 = "Daily or more often";
}

export class MainRole {
    static o1 = "Programmer / Software Developer";
    static o2 = "Tester";
    static o3 = "Analyst";
    static o4 = "Software Architect";
    static o5 = "IT Operations";
    static o6 = "Manager";
    static o7 = "Other";
}

export class TeamSize {
    static o1 = "1 person";
    static o2 = "2-5 people";
    static o3 = "6-10 people";
    static o4 = "11-20 people";
    static o5 = "21-50 people";
    static o6 = "Over 50 people";
}

export class FrequencyAsk {
    static o1 = "Not at all";
    static o2 = "About once a month";
    static o3 = "About once a week";
    static o4 = "Daily or more often";
}

export class InfoSource {
    static o1 = "Online Forums (Stack Overflow, etc)";
    static o2 = "Peers";
    static o3 = "AI-Tools (ChatGPT, Claude, etc)";
    static o4 = "Others";
}

export class RequestDemographics {
    constructor(auth_token, gender, age, education_level, employment_status, frequency_ask, info_source, activity_years, activity_months, main_role, team_size) {
        this.auth_token = auth_token;
        this.gender = gender;
        this.age = age;
        this.education_level = education_level;
        this.employment_status = employment_status;
        this.frequecy_ask = frequency_ask;
        this.info_source = info_source;
        this.activity_years = activity_years;
        this.activity_months = activity_months;
        this.main_role = main_role;
        this.team_size = team_size;
    }
}

export class ResponseDemographics {
    constructor(isFull) {
        this.is_full = isFull;
    }
}

export class ErrorDemographics extends Error {
    constructor(message) {
        super(message);
        this.name = "ErrorDemographics";
    }
}

export class OverallLevel {
    static o1 = "Very dissatisfied";
    static o2 = "Moderately dissatisfied";
    static o3 = "Neither";
    static o4 = "Moderately satisfied";
    static o5 = "Very satisfied";
}

export class RequestEndOfDay {
    constructor(auth_token, types, types_ext, overall) {
        this.auth_token = auth_token;
        this.types = types;
        this.types_ext = types_ext;
        this.overall = overall;
    }
}

export class ResponseEndOfDay {}

export class ErrorEndOfDay extends Error {
    constructor(message) {
        super(message);
        this.name = "ErrorEndOfDay";
    }
}


/**
 * Sends a POST request with JSON data to the specified endpoint.
 *
 * @param {string} url - The endpoint URL.
 * @param {object} data - The JSON data to send.
 * @param {object} [headers={}] - Optional headers to include in the request.
 * @returns {Promise<object>} - A promise that resolves to the response data.
 */
export async function postJson(url, data, headers = {}) {
    // Ensure headers includes 'Content-Type: application/json'
    const finalHeaders = {
        'Content-Type': 'application/json',
        ...headers
    };

    // Send POST request
    const response = await fetch(url, {
        method: 'POST',
        headers: finalHeaders,
        body: JSON.stringify(data)
    });

    // Check if the response is successful
    if (!response.ok) {
        const errorData = await response.json(); // Parse the JSON response
        const error = new Error(errorData.error || 'Unknown error');
        error.response = errorData; // Attach the JSON response to the error object
        throw error;
    }

    // Parse and return JSON response
    const responseData = await response.json();
    return responseData;
}

